import { render } from "./pyramide.vue?vue&type=template&id=67b20fc2&scoped=true"
import script from "./pyramide.vue?vue&type=script&lang=js"
export * from "./pyramide.vue?vue&type=script&lang=js"

import "./pyramide.vue?vue&type=style&index=0&id=67b20fc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67b20fc2"]])

export default __exports__